export default __webpack_public_path__ + "static/lucy-porter-34f7643bb5be4e3990b26a161b59fb59.png";